import React, { useEffect, useState } from 'react';
import forEach from 'lodash/forEach';
import markerIcons from '../../Mapbox/MarkersMap/markerIcons';
import DefaultMapbox from '../../Mapbox/DefaultMapbox';
import { ContentRoute, ContentStop, PopupRoute, PopupStop } from '../../Mapbox/Popup';
import { Modal } from 'antd';
import { STEP_TYPE } from '../../../constants';

const StopsMapbox = ({
  mapData,
  routePlan,
  onClickStop,
  stepClicked,
  onClosePopup,
  setClicked,
  clicked,
  setShowMoreRoute,
  routeClicked,
  routeType,
  setRouteType,
  onClickRoute,
  showMoreRoute,
  riderIdsHide,
  orders,
}) => {
  // const [markers, setMarkers] = useState([]);
  // const [polylines, setPolylines] = useState([]);
  const [lngLat, setLngLat] = useState();
  const [showRouteContent, setShowRouteContent] = useState(undefined);
  const contents = [];

  useEffect(() => {
    if (stepClicked && stepClicked.lng && stepClicked.lat && clicked) {
      setLngLat([stepClicked.lng, stepClicked.lat]);
    } else if (lngLat) {
      setLngLat(undefined);
    }
  }, [stepClicked, clicked]);

  useEffect(() => {
    if (showMoreRoute) {
      clickRoute();
    }
  }, [showMoreRoute]);

  // useEffect(() => {
  //   setMarkers(newMarkers);
  //   setPolylines(newPolylines);
  // }, [mapData, riderIdsHide, stepClicked]);

  const newMarkers = [];
  const newPolylines = [];
  if (mapData) {
    const routeIds = Object.keys(mapData).filter((k) => k !== 'unscheduled');
    forEach(routeIds, (routeId) => {
      const route = routePlan?.riders?.find((r) => r.riderId == routeId);
      if (riderIdsHide?.includes(route.riderId)) return;
      const mapRoute = mapData[routeId];
      const steps = mapRoute?.steps;
      const polyline = mapRoute.polyline;
      const color = mapRoute.color;
      forEach(steps, (step, indexStop) => {
        let isCompleted = step.status === 'COMPLETED' || step.orderStatus === 'COMPLETED';
        if (step.type === STEP_TYPE.pickup) {
          const orderIds = step.orderIds || [];
          const routeSteps = route?.steps || [];
          routeSteps.forEach((routeStep) => {
            if (isCompleted || routeStep.type === STEP_TYPE.delivery) return;
            if (routeStep.status !== 'IN_PROGRESS' && orderIds.includes(routeStep.orderId)) isCompleted = true;
          });
        }
        const urlStop = markerIcons[step.type.toLowerCase() + `${isCompleted ? 'End' : ''}`][color];
        const zIndexStop = stepClicked?.id === step.id ? 999 : 1;
        const markerStop = (
          <div
            key={`${step.id}-${step.type}`}
            className="marker"
            onClick={() => {
              setClicked && setClicked(true);
              onClickStop(step);
            }}
            style={{ zIndex: zIndexStop }}
          >
            <img src={urlStop} style={{ width: 30, height: 31 }} alt="" />
            <div
              className="marker__info"
              style={
                step.type === STEP_TYPE.delivery
                  ? {
                      color: !isCompleted ? '#' + color : 'white',
                      fontSize: '11px',
                      fontWeight: 'bold',
                      letterSpacing: -1,
                      paddingRight: 1,
                      // backgroundColor: isCompleted ? '#' + color : 'white',
                      zIndex: 10,
                    }
                  : { top: '2px' }
              }
            >
              {step.type === STEP_TYPE.delivery ? (
                indexStop + 1
              ) : (
                <img
                  src={routePlan.urlPhoto + step.logoFile}
                  style={{ maxWidth: 13, maxHeight: 12, borderRadius: '50%' }}
                  alt=""
                />
              )}
            </div>
          </div>
        );
        newMarkers.push({
          id: step.id,
          content: markerStop,
          latitude: Number(step.lat),
          longitude: Number(step.lng),
          offsetX: 1,
          offsetY: -6,
          style: { zIndex: zIndexStop },
        });
      });

      const urlStart = markerIcons['start'][color];
      const markerStart = (
        <div
          className="marker--driver"
          onClick={() => {
            setClicked && setClicked(true);
            onClickRoute && onClickRoute(route);
            setRouteType && setRouteType('start');
          }}
          style={{ zIndex: 1 }}
        >
          <img src={urlStart} style={{ width: 34, height: 38 }} alt="" />
        </div>
      );

      newMarkers.push({
        id: routeId + 'start',
        content: markerStart,
        latitude: Number(mapRoute.startAddressLat),
        longitude: Number(mapRoute.startAddressLng),
        offsetX: 1,
        offsetY: -6,
        style: { zIndex: 1 },
        className: 'active-pin',
      });

      if (mapRoute.endAddressLat && mapRoute.endAddressLng) {
        const urlEnd = markerIcons['end'][color];
        const markerEnd = (
          <div
            className="marker--driver"
            onClick={() => {
              setClicked && setClicked(true);
              onClickRoute && onClickRoute(route);
              setRouteType && setRouteType('end');
            }}
            style={{ zIndex: 1 }}
          >
            <img src={urlEnd} style={{ width: 34, height: 38 }} alt="" />
          </div>
        );
        newMarkers.push({
          content: markerEnd,
          latitude: Number(mapRoute.endAddressLat),
          longitude: Number(mapRoute.endAddressLng),
          offsetX: 1,
          offsetY: -6,
          style: { zIndex: 1 },
          className: 'active-pin',
        });
      }
      if (polyline) {
        newPolylines.push({
          polyline: polyline,
          strokeColor: `#${color}`,
          strokeWeight: 2,
          strokeOpacity: 0.8,
        });
      }
    });
    if (mapData['unscheduled']?.steps.length > 0) {
      forEach(
        mapData['unscheduled'].steps?.filter((s) => s.type != STEP_TYPE.pickup),
        (stop, index) => {
          if (riderIdsHide?.includes('unassigned')) return;
          const stopOrder = index + 1;
          const markerColor = '606060';
          const urlStop = markerIcons[stop.type.toLowerCase()][markerColor];
          // const zIndexStop = stopClicked?.id === stop.id || stopUnassignedLeft?.id === stop.id ? 999 : stopOrder;
          const markerStop = (
            <div
              key={`${stop.id}`}
              className="marker"
              // onClick={() => {
              //   setClicked && setClicked(true);
              //   onClickStop(stop);
              // }}
              style={{ zIndex: 99 }}
            >
              <img src={urlStop} style={{ width: 24, height: 29 }} alt="" />
              <div
                className="marker__info"
                style={{
                  color: `#${markerColor}`,
                  fontSize: '10px',
                  fontWeight: 'bold',
                }}
              >
                {stopOrder.toString()}
              </div>
            </div>
          );

          newMarkers.push({
            id: stop.id,
            content: markerStop,
            latitude: Number(stop.lat),
            longitude: Number(stop.lng),
            offsetX: 1,
            offsetY: -6,
          });
        },
      );
    }
  }

  const clickRoute = () => {
    const content = getContentRoute();
    setShowRouteContent(content);
    setTimeout(() => {
      setShowMoreRoute && setShowMoreRoute(false);
    }, 1000);
  };

  const getPopupRoute = (type) => {
    return (
      <PopupRoute
        key={`${routeClicked.riderId}-${type}`}
        routeClicked={routeClicked}
        onClosePopup={onClosePopup}
        clickRoute={clickRoute}
        type={type}
      />
    );
  };

  if (routeClicked?.endAddressLat && (routeType === 'end' || routeType === null)) {
    const popupRoute = getPopupRoute('end');
    contents.push(popupRoute);
  }
  if (routeClicked?.startAddressLat && (routeType === 'start' || routeType === null)) {
    const popupRoute = getPopupRoute('start');
    contents.push(popupRoute);
  }

  const getContentRoute = () => {
    const steps = mapData[routeClicked.id]?.steps || [];
    return <ContentRoute routeClicked={routeClicked} onClickStop={onClickStop} steps={steps} orders={orders} />;
  };

  const getContentStop = (step) => {
    // const order = orders.find((o) => o._id === stopClicked.orderId);
    return (
      <ContentStop
        // stop={stop}
        // onClickStop={onClickStop}
        // getStopLeft={getStopLeft}
        // unassignedStops={unassignedStops}
        // clickShowMoreStop={clickShowMoreStop}
        stepClicked={step}
        // stops={stops}
        // setting={setting}
        // order={order}
      />
    );
  };

  const getPopupStop = (stepClicked) => {
    return (
      <PopupStop
        key={stepClicked.id}
        stepClicked={stepClicked}
        onClosePopup={onClosePopup}
        getContentStop={getContentStop}
      />
    );
  };

  if (stepClicked?.lat) {
    const popup = getPopupStop(stepClicked);
    contents.push(popup);
  }
  return (
    <>
      <DefaultMapbox
        markers={newMarkers}
        polylines={newPolylines}
        lngLatMove={lngLat}
        className="mapbox-routePlan-detail"
      >
        {contents}
      </DefaultMapbox>
      <Modal
        centered
        open={!!showRouteContent}
        onCancel={() => setShowRouteContent(undefined)}
        width={1280}
        footer={null}
        zIndex={9999}
        className="showRouteContent"
      >
        {showRouteContent}
      </Modal>
    </>
  );
};

export default StopsMapbox;
